<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import InvoicesListe from "@/components/invoices-list"

import SuppliersApi from "@/services/suppliers-api";
import CustomersApi from "@/services/customers-api";

export default {
  page: {
    title: "Liste des Factures",
    meta: [{ name: "description", content: appConfig.description }]
  },

  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(this.role == 0||this.role == 2){
      this.getSuppliers()
    }

    if(this.role==1 ||this.role == 2){
      this.getCustomers()
    }

    if(this.type != null){
      this.selectedState =  this.invoicesStatus.find(s => s.value === this.type) || null
    }
  },

  computed: {
    type() {
      const t = this.$route.query.type
      return t !== undefined ? Number(t) : null
    }
  },

  components: { Layout,InvoicesListe},
  data() {
    return {
      suppliersList:[],
      selected:null,
      selectedSupplier:null,
      role:null,
      selectedState:null,
      status:null,
      invoicesStatus:[{name :"Impayé",value: 0},{name :"Payé", value: 1}],
      customersList:[],
      selectedCustomer:null,
      selected2:null,
        
    };
  }, 
  methods:{
    getSuppliers(){
      SuppliersApi.getAllSuppliers().then(
        response => {
          this.suppliersList=response;
        }
      )
    },

    getCustomers(){
      CustomersApi.getCustomers().then(
        response => {
          this.customersList=response;
        }
      )
    },

  },
    watch: {
        selected: function() {
            this.selectedSupplier = this.selected ? this.selected.id : null
        },

        selected2: function() {
            this.selectedCustomer = this.selected2 ? this.selected2.id : null
        },

        selectedState: function() {

            this.status = this.selectedState ? this.selectedState.value : null
        },

    }       
    }

</script>

<template>
  <Layout>
   
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
        <div class="card border border-light">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Factures</h2>
                <div class="row mt-2">
                  <div  v-if="role==0 || role==2" class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Fournisseur" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseur" label="name" v-model="selected">
                        <span slot="no-options">Aucun fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <div  v-if="role==1 || role==2" class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Client" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="customersList" placeholder="Client" label="name" v-model="selected2">
                        <span slot="no-options">Aucun client dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>  
                  <div class="col-sm-4 col-xs-0">
                    <b-form-group label="Etat" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="invoicesStatus" placeholder="Etat" label="name" v-model="selectedState" :searchable="false">
                        <span slot="no-options">Aucun etat dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </div>
                <InvoicesListe :selectedSupplier.sync=this.selectedSupplier :status.sync=this.status :customerId.sync=this.selectedCustomer />
    
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>